import { Box, Typography } from "@mui/material";
import { handleClickUrl } from "../util/PortalAppFunction";

interface Props {
  text: string;
  limit?: number;
}

type Text = { text: string, url?: string };
export default function SafeTextWithLinks({ text, limit }: Props) {
  if (!text) return (<></>);

  const orgLines = text.split(/\r\n|\n/);
  const totalLength = orgLines.reduce((acc: number, str: string) => acc + str.length, 0);
  const lines: Text[][] = [];
  let length = 0;
  for (const line of orgLines) {
    const textList: Text[] = [];
    let lastIndex = 0;
    for (const match of Array.from(line.matchAll(/\b(?:https?:\/\/)?(?:www\.[^\s]+|(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})[\S]*\b/g))) {
      const url: string = match[0];
      const urlStartIndex: number = match.index ?? 0;

      if (/^https?:\/\//i.test(url)) {
        // URL より前の文字列
        const str = line.slice(lastIndex, urlStartIndex);
        if (!limit || length + str.length < limit) {
          textList.push({ text: str });
          length += str.length;
          lastIndex += str.length;
        } else {
          const _str = str.slice(0, str.length - (length + str.length - limit));
          textList.push({ text: _str });
          textList.push({ text: "..." });
          length = limit;
          lastIndex = line.length;
          break
        }

        // URL 部分
        if (!limit || length + url.length < limit) {
          textList.push({ text: url, url: url });
          length += url.length;
          lastIndex += url.length;
        } else {
          const _str = url.slice(0, url.length - (length + url.length - limit));
          textList.push({ text: _str, url: url });
          length += _str.length;
          if (length < totalLength) {
            textList.push({ text: "..." });
          }
          lastIndex = line.length;
          break
        }
      } else {
        // http(s)が含まれていなければ通常の文字列として処理
        const str = line.slice(lastIndex, urlStartIndex) + url;
        if (!limit || length + str.length < limit) {
          textList.push({ text: str });
          length += str.length;
          lastIndex += str.length;
        } else {
          const _str = str.slice(0, str.length - (length + str.length - limit));
          textList.push({ text: _str });
          length += _str.length;
          if (length < totalLength) {
            textList.push({ text: "..." });
          }
          lastIndex = line.length;
          break
        }
      }
    }

    // URL より後ろの文字列
    if (lastIndex < line.length) {
      const str = line.slice(lastIndex);
      if (!limit || length + str.length < limit) {
        textList.push({ text: str });
        length += str.length;
      } else {
        const _str = str.slice(0, str.length - (length + str.length - limit));
        textList.push({ text: _str });
        length += _str.length;
        if (length < totalLength) {
          textList.push({ text: "..." });
        }
      }
    }
    lines.push(textList);
    if (limit && length >= limit) {
      break
    }
  };

  return (
    <Box>
      {lines.map((textList: Text[], i: number) => {
        return (
          <Box key={i}>
            {textList.map((text: Text, j: number) => {
              return text.url ? (
                <a onClick={(event: any) => handleClickUrl(event)} href={text.url} target="_blank" rel="noopener noreferrer" key={j}>
                  {text.text}
                </a>
              ) : (
                <Typography component={"span"} key={j}>{text.text}</Typography>
              )
            })}
          </Box>
        )
      })}
    </Box>
  )
}
